var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.partesResolvidas.length
    ? _c(
        "transition-group",
        {
          staticClass: "d-flex flex-column az-gap",
          attrs: { name: "iv2-parte", tag: "div" }
        },
        _vm._l(_vm.partesResolvidas, function(parte) {
          return _c(
            "div",
            {
              key: parte.identidade,
              staticClass: "iv2-parte",
              class: { "iv2-parte--validando": parte.validando }
            },
            [
              _c(
                parte.componente,
                _vm._b(
                  {
                    tag: "component",
                    attrs: {
                      state: parte.state,
                      "tool-call-id": parte.toolCallId,
                      "id-proposta": parte.idProposta || null,
                      label: parte.label,
                      "data-teste": "parte-do-turno",
                      "data-tool-call-id": parte.toolCallId || null,
                      "turno-em-voo": _vm.turnoEmVoo,
                      "somente-leitura": parte.somenteLeitura === true,
                      "etapa-historica": _vm.etapaHistorica,
                      "resposta-do-cartao": _vm.respostaDoCartao,
                      "estado-do-run": _vm.estadoDoRun
                    },
                    on: {
                      respond: function($event) {
                        return _vm.onRespond(parte, $event)
                      },
                      avancar: _vm.avancarNaApresentacao,
                      "open-service": _vm.onOpenService,
                      ask: _vm.onAsk,
                      abrir: function($event) {
                        return _vm.onAbrirArtefato(parte)
                      },
                      fechar: _vm.onFecharArtefato
                    }
                  },
                  "component",
                  parte.props,
                  false
                )
              )
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }